import { IActivities } from "../../interfaces/companyProfile/iActivities";
import { IActivity } from "../../interfaces/companyProfile/iActivity";
import { Activity } from "./activity";

export class Activities implements IActivities {
    page: number;
    activities: IActivity[];

    constructor(activities: IActivities = {} as IActivities) {
        this.page = activities.page;
        this.activities = !!activities.activities ?
            activities.activities.map((element: IActivity) => new Activity(element)) : [];
    }
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/companyProfile/activities.ts